module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Edit-text-a57e64a1cf79c15e95773cede35ec31f.svg";